// src/utils/axios.js
import axios from 'axios';

// 使用相对路径，由 nginx（生产）或 vue-cli proxy（开发）转发到后端
// nginx: location /api/ { proxy_pass http://127.0.0.1:8099; ... }
const axiosInstance = axios.create({
    baseURL: '',
    timeout: 10000, // 超时时间
});

// 请求拦截器
axiosInstance.interceptors.request.use(
    config => {
        // 在发送请求之前做些什么，例如设置token、将数据转为JSON格式等
    //     const token = localStorage.getItem('token');
    //    if (token) {
    //      config.headers['Authorization'] = `Bearer ${token}`;
    //    }
        //config.headers['Authorization'] = 'Bearer your-token';
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        return config;
    },
    error => {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 响应拦截器
axiosInstance.interceptors.response.use(
    response => {
        // 对响应数据做点什么
        if (response.status === 200) {
            return Promise.resolve(response.data)
        }
    },
    error => {
        // 对响应错误做点什么
        return Promise.reject(error);
    }
);

export default axiosInstance;